import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'gf-parent-project-link',
    template: `<p *ngIf="parentProjectUnixName" style="font-weight: normal; margin-left: 72px; margin-top: -1em; font-size: .5em;">
    <span class="text-muted" translate>part of&nbsp;</span><a class="text-muted" uiSref="home.project.summary" [uiParams]="{ unixName: parentProjectUnixName }">{{parentProjectName}}</a>
</p>`
})
export class ParentProjectLinkComponent implements OnInit, OnChanges {

    @Input() project: any = null;
    parentProjectName: string;
    parentProjectUnixName: string;

    constructor() {
    }

    ngOnInit() {
        this.init();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.init();
    }

    init() {
        this.parentProjectName = this.project?.rel?.parent?.name ?? null;
        this.parentProjectUnixName = this.project?.rel?.parent?.unixName ?? null;
    }
}